import { render, staticRenderFns } from "./cat-leave-detail.vue?vue&type=template&id=31a2575d&"
import script from "./cat-leave-detail.vue?vue&type=script&lang=js&"
export * from "./cat-leave-detail.vue?vue&type=script&lang=js&"
import style0 from "./cat-leave-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports